"use client";

import type { User } from "@supabase/supabase-js";
import type { FestivalDetails } from "@workspace/types";
import { TabsList, TabsTrigger } from "@workspace/ui/components/tabs";
import { isLineupOnlyFestival } from "@/lib/features/festival/festival-status";
import { isFestivalPast } from "@/lib/utils/date/formatting";

interface FestivalTabsProps {
	festivalDetails: FestivalDetails | null;
	user: User | null;
	/** Always show reviews/schedule tab even for anonymous users (useful for profile pages) */
	alwaysShowReviewsTab?: boolean;
}

export function FestivalTabs({ festivalDetails, user, alwaysShowReviewsTab = false }: FestivalTabsProps) {
	return (
		<TabsList className="flex w-full flex-row gap-2 sm:inline-flex sm:w-auto">
			{festivalDetails && !isLineupOnlyFestival(festivalDetails) && (
				<>
					<TabsTrigger value="calendar">
						<span className="sm:hidden">Cal</span>
						<span className="hidden sm:inline">Calendar</span>
					</TabsTrigger>
					<TabsTrigger value="time">Time</TabsTrigger>
					<TabsTrigger value="stages">Stages</TabsTrigger>
				</>
			)}
			<TabsTrigger value="artists">Artists</TabsTrigger>
			{/* Show reviews/schedule tab if user is logged in OR if explicitly requested (for profile pages) */}
			{(user || alwaysShowReviewsTab) && (
				<TabsTrigger value="reviews">
					{festivalDetails && isFestivalPast(festivalDetails.end_date)
						? "Reviews"
						: "Schedule"}
				</TabsTrigger>
			)}
		</TabsList>
	);
}
